import React from 'react';
var classNames = require('classnames');

class RadioInputLabel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
    };
  }

  _inputOnChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  render() {
    const {
      name,
      onChange,
      options,
      } = this.props;

    const {
      value,
      } = this.state;

    return (
      <fieldset>
        {options.map((item, key) => (
          <label key={key} className={classNames('label--radio', {'label--selected': item.value === value})}>
            <input
              type="radio"
              value={item.value}
              name={name}
              checked={item.value === value}
              onChange={() => {
                this.setState({
                  value: item.value,
                });
    
                onChange({
                  target: {
                    name: name,
                    value: item.value,
                  }
                });
              }}
            /> {item.label}
          </label>
        ))}
      </fieldset>
    );
  }
}

export default RadioInputLabel;
